import React, { useEffect } from "react";
import AppTranslation from "../../service/app_translation/AppTranslation";
import Div from "../../widget/common/ui/Div";
import { SpacingHeight } from "../../widget/common/ui/Spacing";
import {
  HomeBranchInfo,
  HomeBranchLogo,
  HomeMenu,
  HomeSocial,
} from "./widget/HomeBody";
import { HomeContextImport } from "../../provider/home/HomeContextProvider";
import { ButtonSingle } from "../../widget/common/form/Button";
import Center from "../../widget/common/ui/Center";
import Loader from "../../widget/common/ui/Loader";
import { useDispatch } from "react-redux";
import {
  applyBranchSwitch,
  setBranchInfo,
} from "../../libraries/state_reducers/home/HomeReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../libraries/state_reducers/store";
import SessionStorage from "../../service/storage/SessionStorage";
import StorageKeys from "../../const/StorageKeys";

const HomeContent = (props: { type: number }) => {
  const type: number = props.type;

  const dispatch = useDispatch();
  const switchBranchDetailSelector = useSelector(
    (state: RootState) => state.home.switchBranchDetail
  );

  const {
    branchDetail,
    branchFollowStatus,
    contactList,
    socialLinks,
    homeMenu,
    followingProcessing,
    getBranchDetail,
    handleClickFollowing,
  } = HomeContextImport();

  useEffect(() => {
    getBranchDetail();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (switchBranchDetailSelector !== undefined) {
      SessionStorage.deleteValue(StorageKeys.home_branch_detail);
      getBranchDetail(switchBranchDetailSelector?.branch_id);
      dispatch(applyBranchSwitch({ switchBranchDetail: undefined }));
    }
    // eslint-disable-next-line
  }, [switchBranchDetailSelector]);

  useEffect(() => {
    if (branchDetail != null) {
      dispatch(
        setBranchInfo({
          branchDetail: branchDetail ?? null,
          socialLinks: socialLinks,
          contactList: contactList,
        })
      );
    }
    // eslint-disable-next-line
  }, [branchDetail]);

  return (
    <>
      {branchDetail != null ? (
        <Div className={type === 3 ? "pt-4" : ""}>
          <HomeBranchLogo type={type} branchDetail={branchDetail} />

          <SpacingHeight value={type === 1 ? 14 : 18} />

          <HomeBranchInfo
            type={type}
            branchDetail={branchDetail}
            contactList={contactList}
          />

          <SpacingHeight value={type === 1 ? 25 : type === 2 ? 30 : 33} />

          <Center>
            <ButtonSingle
              handleClick={() =>
                handleClickFollowing(branchDetail!, branchFollowStatus!)
              }
              fontName="book"
              fontSize="13_14"
              width={type === 1 ? 127 : 133}
              height={type === 1 ? 25 : type === 2 ? 35 : 40}
              radius={type === 3 ? 14 : 12}
              processing={followingProcessing}
            >
              {AppTranslation.text(
                branchFollowStatus === "1" ? "following" : "follow"
              )}
            </ButtonSingle>
          </Center>

          <SpacingHeight value={type === 1 ? 25 : type === 2 ? 36 : 38} />

          <HomeSocial type={type} socialLinks={socialLinks} />

          <SpacingHeight value={type === 1 ? 25 : type === 2 ? 50 : 65} />

          <HomeMenu
            type={type}
            branchDetail={branchDetail}
            contactList={contactList}
            homeMenu={homeMenu}
          />

          <SpacingHeight value={type === 3 ? 20 : 0} />
        </Div>
      ) : (
        <Center className="h-100 w-100">{Loader.normal()}</Center>
      )}
    </>
  );
};

export default HomeContent;
